import { VITE_API_MESSAGE } from './host';

export const createWebSocketURL = async (path, token, params) => {
  const baseUrlWs = VITE_API_MESSAGE;

  const cleanPath = path.replace(/^\/+|\/+$/g, '');

  const url = new URL(`${baseUrlWs}${cleanPath}`);

  url.searchParams.append('token', encodeURIComponent(token));

  if (params) {
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.append(key, value);
    }
  }

  return Promise.resolve(url.toString().replace(/\/\?/, '?'));
};
